import * as React from 'react';
import { useState, useEffect } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { withTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import WorkOrderProfitabilitySection from './WorkOrderProfitabilitySection';
import VehicleProfitabilitySection from './VehicleProfitabilitySection';

function ProfitabilityTab({ t, dateParams }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [subTab, setSubTab] = useState(() => {
    return searchParams.get('subtab') === 'vehicles' ? 1 : 0;
  });

  useEffect(() => {
    const subtabParam = searchParams.get('subtab');
    const newSubTab = subtabParam === 'vehicles' ? 1 : 0;
    if (newSubTab !== subTab) {
      setSubTab(newSubTab);
    }
  }, [searchParams]);

  const handleSubTabChange = (e, newValue) => {
    setSubTab(newValue);
    const newParams = { tab: 'profitability' };
    if (newValue === 1) {
      newParams.subtab = 'vehicles';
    }
    setSearchParams(newParams, { replace: true });
  };

  return (
    <Box>
      <Box sx={{ mb: 2 }}>
        <Tabs
          value={subTab}
          onChange={handleSubTabChange}
          sx={{
            '& .MuiTab-root': {
              textTransform: 'none',
              fontWeight: 500,
              minWidth: 'auto',
              px: 2,
            },
          }}
        >
          <Tab label={t('reports.profitability.workOrders')} />
          <Tab label={t('reports.profitability.vehicles')} />
        </Tabs>
      </Box>

      {subTab === 0 ? (
        <WorkOrderProfitabilitySection dateParams={dateParams} />
      ) : (
        <VehicleProfitabilitySection dateParams={dateParams} />
      )}
    </Box>
  );
}

export default withTranslation()(ProfitabilityTab);
